export const brokenMediaFallback = "/broken-image-fallback.png";

// TODO: Set below fallback images to be platform-dependant
export const logoFallbackPath =
  "https://matchwornshirt.imgix.net/assets/MWS_Logo_Wordmark_Master_White.svg";
export const logoSecondaryFallbackPath =
  "https://matchwornshirt.imgix.net/assets/MWS_Logo_Wordmark_Master_Black.svg";
export const bannerFallbackPath =
  "https://matchwornshirt.imgix.net/assets/banner/default-clubheader.png?auto=compress";

export const frameOrderImagePath =
  "https://matchwornshirt.imgix.net/FTG-images-development/featureOptions images/BLACK FRAME.png";
export const ticketOrderImagePath =
  "https://match-worn-shirt.imgix.net/assets/ticket-image.png";

export const framingImage =
  "https://match-worn-shirt.imgix.net/assets/FTG_MWS_BANNER_1500x770_4.png";
